module.exports = __webpack_public_path__ + "img/menu_device_green_icon.b8df0210.svg";